import React from "react";

const Ol = ({
  className,
  style,
  onClick,
  onDoubleClick,
  onMouseOver,
  onMouseOut,
  children,
  layerRef
}) => {
  return (
    <ol
      ref={layerRef}
      className={className}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </ol>
  );
};

export default Ol;
